import { render, staticRenderFns } from "./MovAlertModal.vue?vue&type=template&id=c7a107c6&scoped=true&lang=pug"
import script from "./MovAlertModal.vue?vue&type=script&lang=js"
export * from "./MovAlertModal.vue?vue&type=script&lang=js"
import style0 from "./MovAlertModal.vue?vue&type=style&index=0&id=c7a107c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a107c6",
  null
  
)

export default component.exports